
<template>
    <div class="area">
        <div>
            <div class="gameRecordTitle">
                <span @click="backPage" :class="{colorBlack:returnWaterDetailShow}">{{$t('tradingRecord.title1')}}</span>
                <div class="titleRight" v-show="returnWaterDetailShow">
                    <i></i>
                    <span>{{$t('tradingRecord.title2')}}</span>
                </div>
            </div>


            <el-form ref="form" :model="form">

                <el-form-item :label="$t('tradingRecord.text2')" v-show="!returnWaterDetailShow">
                    <div class="transactionStyle">
                        <span v-for="(item,index) in transaction" :key="index" @click="chooseRecord(item)" :class="{buttonColor:item.id === chooseTransactionId}">{{item.name}}</span>
                    </div>
                </el-form-item>

                <el-form-item :label="$t('tradingRecord.text3')" v-show="chooseTransactionId == 6 && !returnWaterDetailShow">
                    <div class="transactionStyle">
                        <span v-for="(item,index) in interestType" :key="index" @click="interest(item)" :class="{buttonColor:item.id === interestStatusBgc}">{{item.name}}</span>
                    </div>
                </el-form-item>

                <el-form-item :label="$t('tradingRecord.text4')" v-show="!returnWaterDetailShow">
                    <div class="transactionStyle">
                        <span v-for="(item,index) in dateTime" :key="index" @click="chooseTime(item)" :class="{buttonColor:item.id === chooseDateId}">{{item.name}}</span>
                    </div>
                </el-form-item>

                <el-form-item :label="$t('tradingRecord.text5')" v-show="returnWaterDetailShow">
                    <div class="inputWidth inputMar">
                        <el-input v-model="form.moneyMin" class="inputLeft" placeholder="0"></el-input>
                    </div>
                    <el-col class="line" :span="1"></el-col>
                    <div class="inputWidth inputMar">
                        <el-input v-model="form.moneyMax" class="inputLeft" placeholder="0"></el-input>
                    </div>
                </el-form-item>

                <el-form-item :label="$t('tradingRecord.text6')" class="record">
                    <div class="inputWidth">
                        <el-date-picker type="date" :editable="false" :placeholder="$t('record.text1')" v-model="form.startTime" style="width: 100%;"></el-date-picker>
                    </div>
                    <el-col class="line" :span="1"></el-col>
                    <div class="inputWidth">
                        <el-date-picker type="date" :editable="false" :placeholder="$t('record.text1')" v-model="form.endTime" style="width: 100%;"></el-date-picker>
                    </div>
                    <el-col :span="8" class="inputWidth">
                        <div class="button">
                            <span class="query" @click="query(1)">{{$t('record.text2')}}</span>
                            <span class="reset" @click="reset">{{$t('record.text3')}}</span>
                        </div>
                    </el-col>
                    
                </el-form-item>

            </el-form>


            <el-table :data="tableData" style="width: 100%"  v-show="!interestShow && !returnWaterDetailShow && tableData.length > 0" :key="'length1'+tableData.length" :height="chooseTransactionId == 6?'260':'360'">
                <el-table-column prop="orderNo" :label="$t('tradingRecord.text7')" align="center" :resizable="false">
                    <template slot-scope="scope">
                        <div style="display:flex;">
                            <el-button
                            v-clipboard:copy="scope.row.betNo"
                            v-clipboard:success="(type) => onCopyResult('success')"
                            v-clipboard:error="(type) => onCopyResult('error')"
                            class="copybutton">{{$t('gameRecord.text7')}}</el-button>
                            <el-tooltip effect="dark" :content="scope.row.betNo" placement="top-start">
                                <p class="betNo">{{ scope.row.betNo }}</p>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" :label="$t('tradingRecord.text8')" align="center"></el-table-column>
                <el-table-column prop="payChannel" :label="typeOrMode" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="amount" :label="$t('tradingRecord.text9')" align="center"></el-table-column>
                <el-table-column :label="$t('tradingRecord.text10')" align="center" v-if="water">
                    <template slot-scope="scope">
                        <span :class="{ statusColor: (typeOrMode === $t('tradingRecord.text11') && scope.row.status !== $t('tradingRecord.text12')) || (typeOrMode === $t('tradingRecord.text13') && scope.row.status !== $t('tradingRecord.text14')) || (typeOrMode === $t('tradingRecord.text15') && scope.row.status !== $t('tradingRecord.text16'))}">{{ scope.row.status }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="chooseTransactionId==4?$t('tradingRecord.text29'):$t('tradingRecord.text17')" align="center" v-if="typeOrMode == $t('tradingRecord.text18')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type === 16" style="cursor: pointer;color:#E91919;" @click="toDetails(1,scope.row)">{{$t('tradingRecord.text19')}}</span>
                    </template>
                </el-table-column>
                
            </el-table>

            <el-table :data="tableData" v-show="interestShow && !returnWaterDetailShow && tableData.length > 0" border size="medium" ref="multipleTable" height="260" :key="'length2'+tableData.length">
                <el-table-column prop="name" :label="$t('tradingRecord.text20')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="interestCreatedAt" :label="$t('tradingRecord.text21')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="apr" :label="$t('tradingRecord.text22')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="interestEndTime" :label="$t('tradingRecord.text23')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="depositAmount" :label="$t('tradingRecord.text24')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="interest" :label="$t('tradingRecord.text25')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="totalAmount" :label="$t('tradingRecord.text26')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="hour" :label="$t('tradingRecord.text27')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="interestStatus" :label="$t('tradingRecord.text28')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column :label="$t('tradingRecord.text29')" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span class="getBack" v-show="scope.row.buttonText" @click="receive(scope.row)">{{scope.row.buttonText}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-table :data="tableDetail" v-show="returnWaterDetailShow && tableDetail.length > 0" border size="medium" ref="multipleTable" height="450" :key="'length3'+tableData.length">
                <el-table-column prop="createdAt" :label="$t('tradingRecord.text30')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="vendorName" :label="$t('tradingRecord.text31')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="gameName" :label="$t('tradingRecord.text32')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="effectiveBet" :label="$t('tradingRecord.text33')" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="rebateAmount" :label="$t('tradingRecord.text34')" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>

            <div class="null" v-show="tableData.length === 0 || (returnWaterDetailShow && tableDetail.length === 0)" style="height:360px;max-height: 360px;">
                <img loading="lazy" class="nullImg" v-lazy="require('../../../assets/images/xf/null.png')" alt="">
                <p class="nullText">{{$t('record.text4')}}</p>
            </div>

            <div class="borderBottom"></div>
            

            <div class="pagination">
                <div slot="combined" class="summary" v-show="interestShow">
                    <span class="summaryLeft">{{$t('tradingRecord.text35')}}{{totalDeposit}}RMB</span>
                    <span class="summaryRight">{{$t('tradingRecord.text36')}}{{receiveInterest}}RMB</span>
                </div>
                <div v-show="!interestShow"></div>
                <el-pagination small layout="prev, pager, next" :pageSize="10" @current-change="query" :total="total" :current-page.sync="currentPage"></el-pagination>
            </div>
        </div>

        <el-dialog class="receive" :visible.sync="dialogVisible" width="4.26rem" :before-close="handleClose" :show-close="false" style="border-radius: 0.1rem;">
            <span class="title">{{$t('tradingRecord.text37')}}</span>
            <img loading="lazy" class="dialogClose" v-lazy="require('../../../assets/images/xf/close.png')" style="cursor: pointer;" @click="handleClose" />
            <div>
                <p class="p1">￥{{receivePopup.totalAmount}}</p>
                <p class="p2">{{$t('tradingRecord.text38')}}{{receivePopup.interest}}{{$t('tradingRecord.text39')}}</p>
                <p class="p3">{{$t('tradingRecord.text40')}}{{receivePopup.auditFactor}}{{$t('tradingRecord.text41')}}</p>
                <p class="p4" v-show="receivePopup.buttonText == $t('tradingRecord.text42')">{{$t('tradingRecord.text43')}}</p>
            </div>
            <span class="footer-button">
                <el-button @click="cancel()" class="button-left">{{$t('tradingRecord.text44')}}</el-button>
                <el-button type="primary" @click="determine()" class="button-right">{{$t('tradingRecord.text45')}}</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            key: 'value',
            form: {
                startTime: '',
                endTime: '',
                fixedStartTime: '',
                fixedEndTime: '',
                moneyMin:'',
                moneyMax:'',
            },
            dateTime: [
                {
                    name: this.$t('tradingRecord.text46'),
                    id: 1,
                },
                {
                    name: this.$t('tradingRecord.text47'),
                    id: 2,
                },
                {
                    name: this.$t('tradingRecord.text48'),
                    id: 3,
                },
                {
                    name: this.$t('tradingRecord.text49'),
                    id: 4,
                },
            ],
            interestType: [
                {
                    name: this.$t('tradingRecord.text50'),
                    id: '',
                },
                {
                    name: this.$t('tradingRecord.text51'),
                    id: '0',
                },
                {
                    name: this.$t('tradingRecord.text52'),
                    id: '1',
                },
                {
                    name: this.$t('tradingRecord.text53'),
                    id: '2',
                },
            ],
            selectTypeId: '',
            interestStatusBgc: '',
            chooseDateId: -1,
            transaction: [
                {
                    name: this.$t('tradingRecord.text54'),
                    id: 1,
                },
                {
                    name: this.$t('tradingRecord.text55'),
                    id: 2,
                },
                {
                    name: this.$t('tradingRecord.text56'),
                    id: 3,
                },
                {
                    name: this.$t('tradingRecord.text57'),
                    id: 4,
                },
                {
                    name: this.$t('tradingRecord.text58'),
                    id: 5,
                },
                // {
                //     name: this.$t('tradingRecord.text59'),
                //     id: 6,
                // },
            ],
            chooseTransactionId: 1,
            interestShow:false,
            tableData: [],
            tableDetail:[],
            typeOrMode:'',
            currentPage: 1,
            total: 1,
            interestId:'',
            interestStatus:'',
            receiveInterest:'0.00',
            totalDeposit:'0.00',
            dialogVisible:false,
            water:false,
            receivePopup:{},
            returnWaterDetailShow:false,
            betNo:'',
        }
    },
    watch:{
        $route: {
            immediate: true,
            handler() {
                if(this.$route.query.type){
                    this.betNo = '';
                    this.returnWaterDetailShow = true;
                    this.getRebateAmountDetail(1)
                }
            }
        },
        '$i18n.locale'(n){
            if(n){
                this.dateTime = [
                    {
                        name: this.$t('tradingRecord.text46'),
                        id: 1,
                    },
                    {
                        name: this.$t('tradingRecord.text47'),
                        id: 2,
                    },
                    {
                        name: this.$t('tradingRecord.text48'),
                        id: 3,
                    },
                    {
                        name: this.$t('tradingRecord.text49'),
                        id: 4,
                    },
                ],
                this.interestType = [
                    {
                        name: this.$t('tradingRecord.text50'),
                        id: '',
                    },
                    {
                        name: this.$t('tradingRecord.text51'),
                        id: '0',
                    },
                    {
                        name: this.$t('tradingRecord.text52'),
                        id: '1',
                    },
                    {
                        name: this.$t('tradingRecord.text53'),
                        id: '2',
                    },
                ],
                this.transaction = [
                    {
                        name: this.$t('tradingRecord.text54'),
                        id: 1,
                    },
                    {
                        name: this.$t('tradingRecord.text55'),
                        id: 2,
                    },
                    {
                        name: this.$t('tradingRecord.text56'),
                        id: 3,
                    },
                    {
                        name: this.$t('tradingRecord.text57'),
                        id: 4,
                    },
                    {
                        name: this.$t('tradingRecord.text58'),
                        id: 5,
                    },
                    {
                        name: this.$t('tradingRecord.text59'),
                        id: 6,
                    },
                ];
            }
        }
    },
     watch:{
        $route: {
            immediate: true,
            handler() {
                if(this.$route.query.type){
                    this.betNo = '';
                    this.returnWaterDetailShow = true;
                    this.getRebateAmountDetail(1)
                }
            }
        }
    },
    mounted(){
        this.query();
    },
    methods: {
        interest(item) {
            this.interestStatusBgc = item.id;
        },
        onCopyResult(type) {
            if (type === 'success') {
                this.$message({
                    message: this.$t('record.text5'),
                    type: 'success',
                })
            } else {
                this.$message({
                    message: this.$t('record.text6'),
                    type: 'error',
                })
            }
        },
        chooseRecord(item) {
            this.$route.params.id = '';
            this.$route.params.item = '';
            this.chooseTransactionId = item.id;
        },
        chooseTime(item) {
            if (item.id != this.chooseDateId) {
                this.chooseDateId = item.id;
                this.form.startTime = '';
                this.form.endTime = '';
                this.form.fixedStartTime = '';
                this.form.fixedEndTime = '';
            } else {
                this.chooseDateId = -1;
                this.form.startTime = '';
                this.form.endTime = '';
                this.form.fixedStartTime = '';
                this.form.fixedEndTime = '';
            }
        },
        reset(){
            this.interestStatusBgc = '';
            this.form.startTime = '';
            this.form.endTime = '';
            this.chooseDateId = -1;
            this.form.moneyMin = '';
            this.form.moneyMax = '';
        },
        handleClose() {
            this.dialogVisible = false;
        },
        cancel(){
            this.dialogVisible = false;
        },
        // 領取領回
        receive(row){
            this.receivePopup = row;
            this.dialogVisible = true;
        },
        //返水详情查看
        toDetails(val,item){
            this.returnWaterDetailShow = true;
            this.reset();
            this.betNo = item.betNo; 
            this.getDetailByBetNo(val)
        },
        backPage() {
            this.returnWaterDetailShow = false;
            this.reset();
        },
        getRebateAmountDetail(val) {
            let that = this;
            let form = {...that.form};
            that.currentPage = val;
            
            form.startTime ?form.startTime = that.$common.format(form.startTime, 'yyyy-MM-dd HH:mm:ss') :form.startTime = '';
            form.endTime ?form.endTime = that.$common.format(form.endTime, 'yyyy-MM-dd 23:59:59') :form.endTime = '';

            //待领取 status = 0
            let data = {
                memberId: that.$common.getUser().user_id,
                currentPage:val,
                pageSize:10,
                status:0,
                delFlag:0,
                moneyMax:form.moneyMax,
                moneyMin:form.moneyMin,
                startTime:form.startTime,
                endTime:form.endTime,
            }

            that.$http.post(that.$api.getRebateAmountDetail, data, true).then((res) => {
                if (res && res.data && res.data.total > 0) {
                    res.data.list.map((item) => {
                        item.createdAt = that.$common.conversionTime(item.createdAt);
                        item.rebateAmount = that.$common.setNumFixed(item.rebateAmount, 2);
                        item.effectiveBet = that.$common.setNumFixed(item.effectiveBet, 2);
                    });
                    if (res.data.total > 10) {
                        that.total = res.data.total;
                    } else {
                        that.total = 0;
                    }
                    that.tableDetail = res.data.list;
                } else {
                    that.tableDetail = [];
                    that.total = 0;
                    if (res.code !== 0) {
                        let msg = that.$t(`errorCode.${res.code}`) + `(${res.code})` || that.$t('errorCode.webDefault');
                        that.$http.errMsg(msg);
                    }
                }
            });
        },
        getDetailByBetNo(val) {
            let that = this;
            let form = {...that.form};
            that.currentPage = val;
            form.startTime ?form.startTime = that.$common.format(form.startTime, 'yyyy-MM-dd HH:mm:ss'):form.startTime = '';
            form.endTime ?form.endTime = that.$common.format(form.endTime, 'yyyy-MM-dd 23:59:59'):form.endTime = '';

            //批次返水 betNo 单号
            let data = {
                betNo:that.betNo,
                moneyMax:form.moneyMax,
                moneyMin:form.moneyMin,
                startTime:form.startTime,
                endTime:form.endTime,
            }
            
            that.$http.post(that.$api.getDetailByBetNo, data, true).then((res) => {
                if (res && res.data && res.data.length > 0) {
                    res.data.map((item) => {
                        item.createdAt = that.$common.conversionTime(item.createdAt);
                        item.rebateAmount = that.$common.setNumFixed(item.rebateAmount, 2);
                        item.effectiveBet = that.$common.setNumFixed(item.effectiveBet, 2);
                    });
                    if (res.data.total > 10) {
                        that.total = res.data.total;
                    } else {
                        that.total = 0;
                    }
                    that.tableDetail = res.data;
                } else {
                    that.tableDetail = [];
                    that.total = 0;
                    if (res.code !== 0) {
                        let msg = that.$t(`errorCode.${res.code}`) + `(${res.code})`|| that.$t('errorCode.webDefault');
                        that.$http.errMsg(msg);
                    }
                }
            });
        },
        // 立即领取
        determine(){
            let that = this;
            that.$http.put(that.$api.receiveInterest+that.receivePopup.id,'').then((res) => {
                if (res.code === 0) {
                    that.dialogVisible = false;
                    that.$message({
                        'message': that.$t('tradingRecord.text60'),
                        'type': 'success'
                    });
                    that.query();
                }
            });
        },

        query(val = 1) {
            let that = this;
            that.$route.params
            if(that.returnWaterDetailShow){
                if(that.betNo){
                    that.getDetailByBetNo(val);
                }else{
                    that.getRebateAmountDetail(val);
                }
            }else{
                if(that.$route.params.id){
                    that.chooseTransactionId = that.$route.params.id;
                }
                if(that.$route.params.item){
                    that.interestId = that.$route.params.item.id;
                }
                that.currentPage = val;
                that.interestShow = false;
                if (val == 1) {
                    that.form.fixedStartTime = that.$common.dateTime(29)[0];
                    that.form.fixedEndTime = that.$common.dateTime(29)[1];
                }
                let form = {...that.form};
                switch (that.chooseDateId) {
                    // 今日
                    case 1:
                        form.fixedStartTime = that.$common.dateTime(0)[0];
                        form.fixedEndTime = that.$common.dateTime(0)[1];
                        break;
                        // 昨日
                    case 2:
                        form.fixedStartTime = that.$common.dateTime(1)[0];
                        form.fixedEndTime = that.$common.dateTime(1)[1];
                        break;
                        // 近7日
                    case 3:
                        form.fixedStartTime = that.$common.dateTime(6)[0];
                        form.fixedEndTime = that.$common.dateTime(6)[1];
                        break;
                        // 近30日
                    case 4:
                        form.fixedStartTime = that.$common.dateTime(29)[0];
                        form.fixedEndTime = that.$common.dateTime(29)[1];
                        break;
                }
                let startTime, endTime;
                if (form.fixedStartTime == '' && form.fixedEndTime == '' && form.startTime == '' && form.endTime == '') {
                    startTime = that.$common.dateTime(29)[0] + ' 00:00:00';
                    endTime = that.$common.dateTime(29)[1] + ' 23:59:59';
                } else {
                    form.startTime?startTime = that.$common.format(form.startTime, 'yyyy-MM-dd HH:mm:ss'):startTime = `${form.fixedStartTime} 00:00:00`;
                    form.endTime?endTime = that.$common.format(form.endTime, 'yyyy-MM-dd 23:59:59'):endTime = `${form.fixedEndTime} 23:59:59`;
                }
                let data = {};
                switch (that.chooseTransactionId) {
                    // 充值记录
                    case 1:
                        data = {
                            createdAtBegin: startTime || '',
                            createdAtEnd: endTime || '',
                            memberId: that.$common.getUser().user_id || '',
                            currentPage: val,
                            pageSize: 10,
                        };
                        that.$http.post(that.$api.pcOnlinePayRecordsList, data, true).then((res) => {
                            if (res && res.data && res.data.totalRecords > 0) {
                                if (res.data.totalRecords > 10) {
                                    that.total = res.data.totalRecords;
                                } else {
                                    that.total = 0;
                                }
                                res.data.content.map((item) => {
                                    item.betNo = item.orderNo;
                                    item.createdAt = that.$common.conversionTime(item.createdAt);
                                    if (item.type === 41) {
                                        switch (item.status) {
                                            case 0:
                                                item.status = that.$t('tradingRecord.text61');
                                                break;
                                            case 1:
                                            case 5:
                                            case 6:
                                            case 7:
                                                item.status = that.$t('tradingRecord.text62');
                                                break; 
                                            case 2:
                                                item.status = that.$t('tradingRecord.text63');
                                                break;
                                            case 3:
                                                item.status = that.$t('tradingRecord.text64');
                                                break;
                                            case 4:
                                                item.status = that.$t('tradingRecord.text65');
                                                break;
                                        }
                                    } else {
                                        switch (item.status) {
                                            case 0:
                                                item.status = that.$t('tradingRecord.text66');
                                                break;
                                            case 1:
                                                item.status = that.$t('tradingRecord.text67');
                                                break;
                                            case 2:
                                                item.status = that.$t('tradingRecord.text68');
                                                break;
                                            case 3:
                                                item.status = that.$t('tradingRecord.text69');
                                                break;
                                            case 4:
                                                item.status = that.$t('tradingRecord.text70');
                                                break;
                                        }
                                    }
                                    switch (item.type) {
                                        case 3:
                                            item.payChannel = that.$t('tradingRecord.text71');
                                            break;
                                        case 4:
                                            item.payChannel = that.$t('tradingRecord.text72');
                                            break;
                                        case 5:
                                            item.payChannel = that.$t('tradingRecord.text73');
                                            break;
                                        case 11:
                                            item.payChannel = that.$t('tradingRecord.text74');
                                            break;
                                        case 41:
                                            item.payChannel = that.$t('tradingRecord.text75');
                                            break;
                                    }
                                });
                                that.tableData = res.data.content;
                            } else {
                                that.tableData = [];
                                that.total = 0;
                            }
                            that.typeOrMode = that.$t('tradingRecord.text11');
                            that.water = true;
                        });
                    break;

                    // 银行转账
                    case 2:
                        data = {
                            createdAtBegin: startTime || '',
                            createdAtEnd: endTime || '',
                            memberName: that.$common.getUser().username || '',
                            currentPage: val,
                            pageSize: 10,
                        };

                        that.$http.post(that.$api.bankTransfer, data, true).then((res) => {
                            if (res && res.data && res.data.totalRecords > 0) {
                                if (res.data.totalRecords > 10) {
                                    that.total = res.data.totalRecords;
                                } else {
                                    that.total = 0;
                                }
                                res.data.content.map((item) => {
                                    item.betNo = item.orderNo;
                                    item.createdAt = that.$common.conversionTime(item.createdAt);
                                    switch (item.status) {
                                        case 0:
                                            item.status = that.$t('tradingRecord.text76');
                                            break;
                                        case 1:
                                            item.status = that.$t('tradingRecord.text77');
                                            break;
                                        case 2:
                                            item.status = that.$t('tradingRecord.text78');
                                            break;
                                        case 3:
                                            item.status = that.$t('tradingRecord.text79');
                                            break;
                                    }
                                    switch (item.type) {
                                        case 'alipay':
                                            item.payChannel = that.$t('tradingRecord.text80');
                                            break;
                                        case 'wechat':
                                            item.payChannel = that.$t('tradingRecord.text81');
                                            break;
                                        case 'wechath5':
                                            item.payChannel = that.$t('tradingRecord.text82');
                                            break;
                                        case 'zfbh5':
                                            item.payChannel = that.$t('tradingRecord.text83');
                                            break;
                                        case 'unionclound':
                                            item.payChannel = that.$t('tradingRecord.text84');
                                            break;
                                        case 'union':
                                            item.payChannel = that.$t('tradingRecord.text85');
                                            break;
                                        case 'other':
                                            item.payChannel = that.$t('tradingRecord.text86');
                                            break;
                                    }
                                });
                                that.tableData = res.data.content;
                            } else {
                                that.tableData = [];
                                that.total = 0;
                            }
                            that.typeOrMode = that.$t('tradingRecord.text11');
                            that.water = true;
                        });
                        break;

                    // 提款记录
                    case 3:
                        data = {
                            createdAtBegin: startTime || '',
                            createdAtEnd: endTime || '',
                            id: that.$common.getUser().user_id,
                            currentPage: val,
                            pageSize: 10,
                        };
                        that.$http.post(that.$api.withdrawalsRecords, data, true).then((res) => {
                                if (res && res.data && res.data.totalRecords > 0) {
                                    if (res.data.totalRecords > 10) {
                                        that.total = res.data.totalRecords;
                                    } else {
                                        that.total = 0;
                                    }
                                    res.data.content.map((item) => {
                                        item.betNo = item.orderNo;
                                        item.createdAt = that.$common.conversionTime(item.createdAt);
                                        if (item.type === 43) {
                                            switch (item.status) {
                                                case 0:
                                                    item.status = that.$t('tradingRecord.text87');
                                                    break;
                                                case 1:
                                                case 5:
                                                case 6:
                                                case 7:
                                                    item.status = that.$t('tradingRecord.text88');
                                                    break;
                                                case 2:
                                                    item.status = that.$t('tradingRecord.text89');
                                                    break;
                                                case 3:
                                                    item.status = that.$t('tradingRecord.text90');
                                                    break;
                                                case 4:
                                                    item.status = that.$t('tradingRecord.text91');
                                                    break;
                                            }
                                        } else {
                                            switch (item.status) {
                                                case 0:
                                                    item.status = that.$t('tradingRecord.text92');
                                                    break;
                                                case 1:
                                                    item.status = that.$t('tradingRecord.text93');
                                                    break;
                                                case 2:
                                                    item.status = that.$t('tradingRecord.text94');
                                                    break;
                                                case 3:
                                                    item.status = that.$t('tradingRecord.text95');
                                                    break;
                                                case 4:
                                                    item.status = that.$t('tradingRecord.text96');
                                                    break;
                                            }
                                        }
                                        switch (item.type) {
                                            case 8:
                                                item.payChannel = that.$t('tradingRecord.text97');
                                                break;
                                            case 10:
                                                item.payChannel = that.$t('tradingRecord.text98');
                                                break;
                                            case 43:
                                                item.payChannel = that.$t('tradingRecord.text99');
                                                break;
                                            case 47:
                                                item.payChannel = that.$t('tradingRecord.text100');
                                                break;
                                        }
                                    });
                                    that.tableData = res.data.content;
                                } else {
                                    that.tableData = [];
                                    that.total = 0;
                                }
                                that.typeOrMode = that.$t('tradingRecord.text13');
                                that.water = true;
                            });
                    break;

                    // 返水记录
                    case 4:
                    data = {
                        memberId: that.$common.getUser().user_id,
                        currentPage: val,
                        pageSize: 10,
                        startTime: startTime || '',
                        endTime: endTime || '',
                    };
                    that.$http.post(that.$api.rebates, data, true).then((res) => {
                        if (res && res.data && res.data.total > 0) {
                            if (res.data.total > 10) {
                                that.total = res.data.total;
                            } else {
                                that.total = 0;
                            }
                            res.data.list.map((item) => {
                                item.createdAt = that.$common.conversionTime(item.createdAt);
                                item.orderNo = item.betNo;
                                item.amount = that.$common.setNumFixed(item.rebateAmount, 2);
                                item.payChannel = item.typeName;
                            });
                            that.tableData = res.data.list;
                        } else {
                            that.tableData = [];
                            that.total = 0;
                        }
                        that.typeOrMode = that.$t('tradingRecord.text18');
                        that.water = false;
                    });
                    break;

                    // 其它
                    case 5:
                        // eslint-disable-next-line no-case-declarations
                        let data = {
                            currentPage: val,
                            pageSize: 10,
                            createdAtStart: startTime || '',
                            createdAtEnd: endTime || '',
                        };
                        that.$http.post(that.$api.getList, data, true).then((res) => {
                            if (res && res.data && res.data.totalRecords > 0) {
                                if (res.data.totalRecords > 10) {
                                    that.total = res.data.totalRecords;
                                } else {
                                    that.total = 0;
                                }
                                res.data.content.map((item) => {
                                    item.betNo = item.orderNo;
                                    item.amount = that.$common.setNumFixed(item.amount, 2);
                                    item.createdAt = that.$common.conversionTime(item.createdAt);
                                    if (item.type === 42) {
                                        switch (item.status) {
                                            case 0:
                                                item.status = that.$t('tradingRecord.text101');
                                                break;
                                            case 1:
                                            case 5:
                                            case 6:
                                            case 7:
                                                item.status = that.$t('tradingRecord.text102');
                                                break;
                                            case 2:
                                                item.status = that.$t('tradingRecord.text103');
                                                break;
                                            case 3:
                                                item.status = that.$t('tradingRecord.text104');
                                                break;
                                            case 4:
                                                item.status = that.$t('tradingRecord.text105');
                                                break;
                                        }
                                    } else {
                                        switch (item.status) {
                                            case 0:
                                                item.status = that.$t('tradingRecord.text106');
                                                break;
                                            case 1:
                                                item.status = that.$t('tradingRecord.text107');
                                                break;
                                            case 2:
                                                item.status = that.$t('tradingRecord.text108');
                                                break;
                                            case 3:
                                                item.status = that.$t('tradingRecord.text109');
                                                break;
                                        }
                                    }

                                    switch (item.type) {
                                        case 6:
                                            item.payChannel = that.$t('tradingRecord.payChannel1');
                                            break;
                                        case 7:
                                            item.payChannel = that.$t('tradingRecord.payChannel2');
                                            break;
                                        case 11:
                                            item.payChannel = that.$t('tradingRecord.payChannel3');
                                            break;
                                        case 12:
                                            item.payChannel = that.$t('tradingRecord.payChannel4');
                                            break;
                                        case 13:
                                            item.payChannel = that.$t('tradingRecord.payChannel5');
                                            break;
                                        case 14:
                                            item.payChannel = that.$t('tradingRecord.payChannel6');
                                            break;
                                        case 15:
                                            item.payChannel = that.$t('tradingRecord.payChannel7');
                                            break;
                                        case 20:
                                            item.payChannel = that.$t('tradingRecord.payChannel8');
                                            break;
                                        case 21:
                                            item.payChannel = that.$t('tradingRecord.payChannel9');
                                            break;
                                        case 22:
                                            item.payChannel = that.$t('tradingRecord.payChannel10');
                                            break;
                                        case 23:
                                            item.payChannel = that.$t('tradingRecord.payChannel11');
                                            break;
                                        case 25:
                                            item.payChannel = that.$t('tradingRecord.payChannel12');
                                            break;
                                        case 26:
                                            item.payChannel = that.$t('tradingRecord.payChannel13');
                                            break;
                                        case 27:
                                            item.payChannel = that.$t('tradingRecord.payChannel14');
                                            break;
                                        case 28:
                                            item.payChannel = that.$t('tradingRecord.payChannel15');
                                            break;
                                        case 31:
                                            item.payChannel = that.$t('tradingRecord.payChannel16');
                                            break;
                                        case 32:
                                            item.payChannel = that.$t('tradingRecord.payChannel17');
                                            break;
                                        case 33:
                                            item.payChannel = that.$t('tradingRecord.payChannel18');
                                            break;
                                        case 34:
                                            item.payChannel = that.$t('tradingRecord.payChannel19');
                                            break;
                                        case 35:
                                            item.payChannel = that.$t('tradingRecord.payChannel20');
                                            break;
                                        case 36:
                                            item.payChannel = that.$t('tradingRecord.payChannel21');
                                            break;
                                        case 42:
                                            item.payChannel = that.$t('tradingRecord.payChannel22');
                                            break;
                                        case 44:
                                            item.payChannel = that.$t('tradingRecord.payChannel23');
                                            break;
                                        case 45:
                                            item.payChannel = that.$t('tradingRecord.payChannel24');
                                            break;
                                        case 46:
                                            item.payChannel = that.$t('tradingRecord.payChannel25');
                                            break;
                                        case 50:
                                            item.payChannel = that.$t('tradingRecord.payChannel26');
                                            break;
                                        case 51:
                                            item.payChannel = that.$t('tradingRecord.payChannel27');
                                            break;
                                        case 52:
                                            item.payChannel = that.$t('tradingRecord.payChannel28');
                                            break;
                                        case 53:
                                            item.payChannel = that.$t('tradingRecord.payChannel29');
                                            break;

                                        case 62:
                                            item.payChannel = that.$t('tradingRecord.payChannel31');
                                            break;
                                        case 63:
                                            item.payChannel = that.$t('tradingRecord.payChannel32');
                                            break;
                                        case 64:
                                            item.payChannel = that.$t('tradingRecord.payChannel33');
                                            break;
                                        case 65:
                                            item.payChannel = that.$t('tradingRecord.payChannel34');
                                            break;
                                        case 66:
                                            item.payChannel = that.$t('tradingRecord.payChannel35');
                                            break;
                                        case 67:
                                            item.payChannel = that.$t('tradingRecord.payChannel36');
                                            break;
                                        case 68:
                                            item.payChannel = that.$t('tradingRecord.payChannel37');
                                            break;
                                        case 69:
                                            item.payChannel = that.$t('tradingRecord.payChannel38');
                                            break;

                                        case 99:
                                            item.payChannel = that.$t('tradingRecord.payChannel30');
                                            break;
                                        case 62:
                                            item.payChannel = '信息认证';
                                            break;
                                        case 63:
                                            item.payChannel = '周勤奖励';
                                            break;
                                        case 64:
                                            item.payChannel = '幸运注单';
                                            break;
                                        case 65:
                                            item.payChannel = '周年礼金';
                                            break;
                                        case 66:
                                            item.payChannel = '棋牌奖励';
                                            break;
                                        case 67:
                                            item.payChannel = '棋牌救援';
                                            break;
                                        case 68:
                                            item.payChannel = '千倍百倍';
                                            break;
                                        case 69:
                                            item.payChannel = '亿元回馈';
                                            break;
                                        case 70:
                                            item.payChannel = '大转盘';
                                            break;
                                        case 73:
                                            item.payChannel = '站内活动';
                                            break;
                                        case 72:
                                            item.payChannel = '积分商城抽奖';
                                            break;
                                    }
                                });
                                that.tableData = res.data.content;
                            } else {
                                that.tableData = [];
                                that.total = 0;
                            }
                            that.typeOrMode = that.$t('tradingRecord.text15');
                            that.water = true;
                        });
                    break;
                    case 6:
                        that.interestShow = true;
                        data = {
                            currentPage: val,
                            interestId: that.interestId,
                            pageSize: 10,
                            status: that.interestStatusBgc,
                            startTime: startTime || '',
                            endTime: endTime || '',
                        };
                        that.$http.post(that.$api.interestRecord, data, true).then((res) => {
                            if (res.data) {
                                if (res.data.totalRecords > 0) {
                                    that.receiveInterest = that.$common.setNumFixed(res.data.receiveInterest,2);
                                    that.totalDeposit = that.$common.setNumFixed(res.data.totalDeposit,2);
                                    if (res.data.totalRecords > 10) {
                                        that.total = res.data.totalRecords;
                                    } else {
                                        that.total = 0;
                                    }
                                    res.data.content.map((item) => {
                                        item.interestCreatedAt = that.$common.conversionTime(item.createdAt);
                                        item.interestEndTime = that.$common.conversionTime(item.interestEndTime);
                                        item.depositAmount = that.$common.setNumFixed(item.depositAmount,2);
                                        item.totalAmount = that.$common.setNumFixed(Number(item.depositAmount) + Number(item.interest),2);
                                        item.apr = item.apr + '%';
                                        item.hour = item.hour + that.$t('tradingRecord.interestRecord1');
                                        if (item.status == 1) {
                                            item.buttonText = that.$t('tradingRecord.interestRecord2');
                                        } else if (item.status == 0) {
                                            item.buttonText = that.$t('tradingRecord.interestRecord3');
                                        }
                                        switch (item.status) {
                                            case 0:
                                                item.interestStatus = that.$t('tradingRecord.interestRecord4');
                                                break;
                                            case 1:
                                                item.interestStatus = that.$t('tradingRecord.interestRecord5');
                                                break;
                                            case 2:
                                                item.interestStatus = that.$t('tradingRecord.interestRecord6');
                                                break;
                                        }
                                    });
                                    that.tableData = res.data.content;
                                }else{
                                    that.tableData = [];
                                    that.receiveInterest = '0.00'
                                    that.totalDeposit = '0.00'
                                    that.total = 0;
                                }
                            } else {
                                that.tableData = [];
                                that.receiveInterest = '0.00'
                                that.totalDeposit = '0.00'
                                that.total = 0;
                            }

                        });
                    break;
                }
            }
            
        },
    },
}
</script>


<style lang="scss" scoped>
@import url('./record.css');
.el-form-item{
    margin-bottom: 35px;
}
.line{
    width: 20px;
    height: 1px;
    border-top: 1px solid #313131;
    margin: 0 10px;
}
.transactionStyle{
    display: flex;
    flex-wrap: wrap;
    span{
        cursor: pointer;
        width: 107px;
        height: 34px;
        border: 1px solid #CCCCCC;
        text-align: center;
        line-height: 34px;
        margin-right: 10px;
        border-radius: 17px;
        color: #333333;
        &:hover {
            border-color: #E91919;
            background: #E91919;
            color: #ffffff;
        }
    }
    .buttonColor{
        border-color: #E91919;
        background: #E91919;
        color: #ffffff;
    }
}
.copybutton {
    border: none;
    color:#E91919;
    background: none;
    padding: 0 5px;
    font-size: 0.14rem !important;
    padding-top: 0.02rem;

}
.betNo{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 1.3rem;
    font-size: 0.14rem !important;
}
.borderBottom{
    height: 1px;
    background: #CDD8E0;
    margin-top: 23px;
}

.pagination{
    width: 100%;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
}
.statusColor {
    color: #E91919 !important;
    width:
     100%;
}
.summary{
    display: flex;
    margin: 5px 0;
    font-weight: 600;
    .summaryLeft{
        margin-right: 50px;
    }
}
.gameRecordTitle{
    color: #3E444D;
    font-size: 14px;
    display: flex;
    margin-top: 25px;
    .titleRight{
        display: flex;
        align-items: center;
        i{
            width: 7px;
            height: 12px;
            background: url('../../../assets/images/xf/connectionIcon.png') no-repeat;
            background-size: 100% 100%;
            margin: 0 20px;
        }
    }
    .colorBlack{
        cursor: pointer;
        font-weight: bold;
        color: #3E444D;
    }
}
</style>
<style lang="less">
.receive{
    .el-dialog {
        min-width: 426px;
        padding-bottom: 10px;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        margin-top: 0 !important;
        .el-dialog__body {
            padding: 0;
            height: 100%;
        }
        .el-button {
            padding: 0;
        }
    }
    p{
        margin-top: 10px;
        text-align: center;
    }
    .p1{
        color: #333333;
        font-size: 32px;
        margin-top: 20px;
    }
    .p2{
        color: #2D2B4D;
        font-size: 14px;
        font-weight: 500;
    }
    .p3{
        color: #1D1717;
        font-size: 18px;
        font-weight: 500;
    }
    .p4{
        color: #A7A7A7;
        font-size: 14px;
        font-weight: 500;
    }
    .title {
        height: 0.55rem;
        box-sizing: border-box;
        border-radius: 0.1rem 0.1rem 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.28rem;
        padding-top: 0.32rem;
        color: #333333;
        font-weight: bold;
    }
    .el-dialog__close {
        font-size: 0.3rem;
    }
    .footer-button {
        display: flex;
        justify-content: space-around;
        margin: 20px 0;
        .el-button {
            width: 131px;
            height: 46px;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            border: none;
            border-radius: 22px;
        }
        .button-left {
            margin-left: 40px;
            border: 1px solid #E91919;
            color: #E91919;
            &:hover{
                background-color: #ffffff;
            }
        }
        .button-right {
            margin-right: 0.4rem;
            color: #ffffff;
            background: #E91919;
        }
        
    }
    .el-dialog__header {
        padding: 0;
    }
    .dialogClose {
        width: 17px;
        height: 17px;
        position: absolute;
        top: 0.14rem;
        right: 0.14rem;
        transition: 1s;
    }
    .el-button--primary{
        border: none;
    }
    
}

</style>